import { render, staticRenderFns } from "./ProductionStatistics.vue?vue&type=template&id=2ebf7860"
import script from "./ProductionStatistics.vue?vue&type=script&lang=js"
export * from "./ProductionStatistics.vue?vue&type=script&lang=js"
import style0 from "./ProductionStatistics.vue?vue&type=style&index=0&id=2ebf7860&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports